import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SearchIcon from '../../assets/icons/SearchIcon';
import { useProductStore } from '../../store/productStore';

interface SearchInputProps {
  placeholder?: string;
}

function SearchInput({ placeholder }: SearchInputProps) {
  const { filters, setFilter } = useProductStore();
  const [localQuery, setLocalQuery] = useState(filters.search || "");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get("search") || "";
    setLocalQuery(searchParam);
    setFilter("search", searchParam);
  }, [location.search, setFilter]);

  const handleSearch = () => {
    if (localQuery.trim() === "") {
      setFilter("search", "");
      const params = new URLSearchParams(window.location.search);
      params.delete("search");
      navigate(`/catalog?${params.toString()}`);
      return;
    }

    setFilter("search", localQuery);
    const params = new URLSearchParams(window.location.search);
    params.set("search", localQuery);
    if (location.pathname !== "/catalog") {
      navigate(`/catalog?${params.toString()}`);
    } else {
      navigate(`?${params.toString()}`);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <div className="relative w-full">
      <input
        type="text"
        value={localQuery}
        onChange={(e) => setLocalQuery(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={placeholder || 'Введите текст...'}
        className="w-full py-1.5 px-3 pr-10 border border-gray-300 rounded-full focus:outline-none"
      />
      <button
        onClick={handleSearch}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-gray-500 hover:text-black focus:outline-none"
      >
        <SearchIcon className="w-5 h-5" />
      </button>
    </div>
  );
}

export default SearchInput;
